var map = {
	"./cloud.webp": 3182,
	"./fire.webp": 8872,
	"./ice.webp": 5275,
	"./light.webp": 5663,
	"./undead.webp": 9006,
	"./water.webp": 4032,
	"./windy.webp": 2733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 398;